import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import { forwardRef } from "react";

import {
  type TNavigationMenuItemElement,
  type TNavigationMenuItemProps,
} from "@/ui/components/navigation/NavigationMenu/NavigationMenu.config";
import { cn } from "@/ui/lib/utils";

export const NavigationMenuItem = forwardRef<
  TNavigationMenuItemElement,
  TNavigationMenuItemProps
>(({ className, ...props }, ref) => (
  <NavigationMenuPrimitive.Item
    ref={ref}
    data-component="NavigationMenuItem"
    className={cn("relative", className)}
    {...props}
  />
));

NavigationMenuItem.displayName = NavigationMenuPrimitive.Item.displayName;
